import { Message } from '@arco-design/web-react';
import { Toast as MobileToast } from '@arco-design/mobile-react';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { warning_fill, error_fill, success_fill, close, info_fill, success_circle_fill } from '@shared/assets/svg/base';
import styles from './index.module.less';
import { ReactNode } from 'react';
import i18n from '@shared/i18n/index';
import { isMobile } from 'react-device-detect';

let count = 0;

class ToastV2 {
	static success(
		content: string | ReactNode,
		duration?: number,
		onClose?: () => void,
		closable = false,
		isLight = false,
	) {
		return ToastV2.toast('success', content, duration, closable, onClose, isLight);
	}
	static error(content: string, duration?: number, onClose?: () => void, closable = false, isLight = false) {
		return ToastV2.toast('error', content, duration, closable, onClose, isLight);
	}
	static warning(content: string, duration?: number, onClose?: () => void, closable = false, isLight = false) {
		return ToastV2.toast('warning', content, duration, closable, onClose, isLight);
	}
	static info(
		content: string | ReactNode,
		duration?: number,
		onClose?: () => void,
		closable = false,
		isLight = false,
	) {
		return ToastV2.toast('info', content, duration, closable, onClose, isLight);
	}
	private static toast(
		type: 'info' | 'warning' | 'success' | 'error',
		content: string | ReactNode,
		duration = isMobile ? 4000 : 2000,
		closable: boolean,
		onClose?: () => void,
		isLight = false,
	) {
		const ICON_TYPE = {
			info: <NewBaseIcon icon={info_fill} className={styles.info_icon} />,
			warning: <NewBaseIcon icon={warning_fill} className={styles.warning_icon} />,
			error: <NewBaseIcon icon={error_fill} className={styles.error_icon} />,
			success: <NewBaseIcon icon={isLight ? success_circle_fill : success_fill} className={styles.success_icon} />,
		};

		// 如果是移动设备，使用移动端Toast组件
		if (isMobile && typeof content === 'string') {
			// 关闭已存在的Toast实例
			if (window.toastInstance) {
				window.toastInstance.close();
			}

			const params = {
				icon: <span className={styles.mobile_toast_icon}>{ICON_TYPE[type]}</span>,
				content: content,
				duration,
				layout: 'horizontal',
				direction: 'top',
				className: isLight ? styles.light_toast : '',
				onClose,
			} as const;

			// 根据类型调用不同的移动端Toast方法
			switch (type) {
				case 'success':
					window.toastInstance = MobileToast.toast(params);
					break;
				case 'error':
					window.toastInstance = MobileToast.toast(params);
					break;
				case 'warning':
					window.toastInstance = MobileToast.toast(params);
					break;
				case 'info':
				default:
					window.toastInstance = MobileToast.toast(params);
					break;
			}

			return window.toastInstance;
		}

		return Message[type]({
			style: {
				pointerEvents: 'none',
			},
			content,
			duration,
			closable,
			icon: ICON_TYPE[type],
			onClose,
			id: isMobile ? '1' : (count++).toString(),
			closeIcon: <NewBaseIcon icon={close} className={styles.close_btn} />,
			className: styles.custom_message + (isLight ? ' ' + styles.light_toast : ''),
		});
	}

	static custom(Cpn: React.ReactNode) {
		return Message.normal({
			content: Cpn,
			type: 'normal',
			className: [styles.overrideCustom],
		});
	}
}

export class PartToast {
  static toast(
    content: string | ReactNode,
    duration = 2000,
  ) {
    // 关闭已存在的Toast实例
    if (window.toastInstance) {
      window.toastInstance.close();
    }

    const params = {
      content: content,
      duration,
      layout: 'horizontal',
      direction: 'top',
      className: styles.part_toast,
    } as const;

    window.toastInstance = MobileToast.toast(params);

    return window.toastInstance;
  }
}

export const CopiedLinkToast = () => {
	ToastV2.success(<>{i18n.get('Business_Share_Copy_Toast')}</>);
};

export default ToastV2;
